import { Injectable, Inject } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { LoiHttpClient } from 'loi-lti-common';
import { StudentCurriculumModel } from '../models/student.curriculum.model';
import { CustomRequestOptions } from '../utils/custom-request-options';

@Injectable({
  providedIn: 'root'
})
export class StudentCurriculumService {
  constructor(
    private httpClient: LoiHttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private requestOptions: CustomRequestOptions) { }

  getStudentCurriculum(): Observable<StudentCurriculumModel> {
    console.log('retreiving student curriculum')
    return this.httpClient.get<StudentCurriculumModel>(`${this.baseUrl}api/Activation/StudentCurriculum`, this.requestOptions);
  }
}

